import { render } from "./TreasureHuntTab.vue?vue&type=template&id=2bca51d4&scoped=true&ts=true"
import script from "./TreasureHuntTab.vue?vue&type=script&lang=ts"
export * from "./TreasureHuntTab.vue?vue&type=script&lang=ts"

import "./TreasureHuntTab.vue?vue&type=style&index=0&id=2bca51d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bca51d4"]])

export default __exports__